/**
 * Created by mykurisu on 2017/7/3.
 */
const defaults = {
    ActionSheetShow: false,
    QrcodeShow: false,
    RefundShow: false,
    buyInitialized: false,
    listenInitialized: false,
    buyList: [],
    buy: null,
    listenList: [],
    listen: null,
    selectInvoice: null,
    refundStatus: null,
    objectId: null,
    selectIndex: null,
}

export default(state = defaults, action) => {
    switch (action.type) {
        case 'ACTIONSHEET_SHOW':
            return {...state, ActionSheetShow: true}
        case 'ACTIONSHEET_HIDE':
            return {...state, ActionSheetShow: false}
        case 'QRCODE_SHOW':
            return {...state, QrcodeShow: true}
        case 'QRCODE_HIDE':
            return {...state, QrcodeShow: false}
        case 'REFUND_SHOW':
            return {...state, RefundShow: true}
        case 'REFUND_HIDE':
            return {...state, RefundShow: false}
        case 'BUY_LIST':
            return {...state, buyInitialized: true, buy: action.payload}
        case 'LISTEN_LIST':
            return {...state, listenInitialized: true, listen: action.payload}
        case 'BUY_LIST_INIT':
            return {...state, buyList: action.payload}
        case 'LISTEN_LIST_INIT':
            return {...state, listenList: action.payload}
        case 'SET_INVOICEID':
            return {...state, selectInvoice: action.payload}
        case 'CLEAR_INVOICEID':
            return {...state, selectInvoice: null}
        case 'SET_REFUNDSTATUS':
            return {...state, refundStatus: action.payload}
        case 'BUY_LIST_APPEND':
            return {...state,
                buyList: [...state.buyList,...action.payload]};
        case 'LISTEN_LIST_APPEND':
            return {...state,
                listenList: [...state.listenList,...action.payload]};
        case 'SET_OBJECT_ID':
            return {...state, objectId: action.payload};
        case 'SET_SELECT_INDEX':
            return {...state, selectIndex: action.payload};
        case 'SET_REFUND_STATUS':
            state.buyList[action.payload].can_apply_refund = false;
            state.buyList[action.payload].refund_status = 'refunding';
            return {...state, ...state.buyList, refund_status_re: action.payload}
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/record.js